const VERIFICATION_KYC = "VERIFICATION_KYC_ONBOARDING";
const ERROR_NOTIFICATION = "Sorry, something went wrong";
const RELOAD_INTERVAL_API_ERROR = 400;

export { VERIFICATION_KYC, ERROR_NOTIFICATION, RELOAD_INTERVAL_API_ERROR };
